import { render, staticRenderFns } from "./form_group.vue?vue&type=template&id=650ad1c4&"
import script from "./form_group.vue?vue&type=script&lang=js&"
export * from "./form_group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports